import './RadioFormat.css';
interface Props {
	title: string;
	name: string;
	setValue: (value: string) => void;
	value: string;
}
export const RadioFormat = (props: Props) => {
	const DATA_FORMATS = ['JSON', 'XML', 'YAML'];
	const radios = DATA_FORMATS.map((format) => {
		return (
			<div className='radio' key={format + '-div'}>
				<label>
					<input
						type='radio'
						key={format}
						value={format}
						name={props.name}
						checked={format === props.value}
						onChange={(e) => {
							props.setValue(e.target.value);
						}}
					/>
					{format}
				</label>
			</div>
		);
	});

	return (
		<div className='radio-group'>
			<div className='radioheader'>
				<h2>{props.title}</h2>
			</div>
			<div className='radio-choices'>{radios}</div>
		</div>
	);
};
